import  levenshteinDistance  from '../utils/levenshteinDistance';


export const questionOptionsForSelectMultipleThatMatchSpokenAnswer = (
    questionAnswerValue: any,
    spokenAnswer: String,
    questionOptions: Array<string>
) => {

    // keep any existing options
    const matchingOptions: string[] = questionAnswerValue && questionAnswerValue instanceof Array ? [...questionAnswerValue] : []

    // split spoken answer into an array of individual words
    const spokenWords = spokenAnswer.toLowerCase().split(' ')

    // check if any of the spoken words match the question options
    questionOptions.forEach((option: string) => {
        if (spokenWords.includes(option.toLowerCase())) {
            matchingOptions.push(option)
        } else {
            // if not an exact match, check if any of the spoken words are close matches to the option (levenshtein distance of 1 or less)
            for (const word of spokenWords) {
                const distance = levenshteinDistance(option.toLowerCase(), word);
                const threshold = option.length <= 2 ? 0 : 1; // Allow a distance of 0 for short options, 1 for longer options
                if (distance <= threshold) {
                    matchingOptions.push(option)
                    break;
                }
            }
        }

    })

    // remove any duplicates
    const uniqueOptions = Array.from(new Set(matchingOptions))

    return uniqueOptions
}

